<template>
  <div class="xinTu-menu">
    <div class="xinTu-content">
      <img src="../assets/logo.png" class="logo" alt="">
    </div>
    <div class="xinTu-menubox">
      <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Ngành Công Nghiệp</div>
      <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
        Phát Triển
      </div>
      <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
        Phục Vụ
      </div>
      <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">
        Phát triển công ty
      </div>
      <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
        Liên Hệ Chúng Tôi
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "categories" });
          break;
        case 3:
          this.$router.push({ path: "destination" });
          break;
        case 4:
          this.$router.push({ path: "privacy" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;

        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.xinTu-menu {
  width: 480px;
  min-height: 100vh;
  background: #DBA35C;

  .xinTu-content {
    display: flex;
    margin-bottom: 60px;

    .logo {
      margin: 147px auto 0;
      width: 167px;
      height: 69px;
    }

  }

  .xinTu-menubox {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;
    font-family: KronaOne, KronaOne;
    font-weight: 400;
    color: #333333;
    line-height: 30px;

    div {
      cursor: pointer;
      margin-bottom: 11px;
    }
  }

  .select {
    color: #FFFFFF;
  }
}
</style>
